/**
 *  项目的配置文件
 */
const getQueryVariable = (variable) => {
     let query = window.location.search.substring(1);
     let vars = query.split("&");
     for (let i = 0; i < vars.length; i++) {
          let pair = vars[i].split("=");
          if (pair[0] == variable) {
               return pair[1];
          }
     }
     return false;
}

//确保第一时间获取到 identity值，要不然打开则undefined
export const getIdentity = () => {
     if (localStorage.identity && localStorage.identity != 'false') {
          return localStorage.identity
     } else {
          if (getQueryVariable('storeId')) return 'seller'
          if (getQueryVariable('adminId')) return 'admin'
     }
}

export const apiUrl = `https://${getIdentity()}.laidiangang.com/`//接口请求地址
export const chatUrl = 'https://im.laidiangang.com'//客服地址
export const sourceUrl = `https://${getIdentity()}.laidiangang.com/`//来源地址，当用户失去登录态时需跳转到来源登录页
export const pcUrl = 'https://pc.laidiangang.com/'
export const identity = getIdentity()
export const curLang = 'zh';//当前语言,zh:中文，若为其他语言，需要对应/src/assets/language下面的文件名
export const title = 'B2B';//浏览器顶部title

/** copyright *** slodon *** version-v3.4 *** date-2023-01-07 ***主版本v3.7**/

